var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 138,
    viewBox: "0 0 73 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.9656 118.968H67.8165V136.5H1.5V120.099L34.2434 69.4781L34.2452 69.4753C36.7033 65.6569 38.9951 62.0051 41.1204 58.52C43.3993 54.9674 45.2303 51.3466 46.6075 47.6578C48.1269 43.7767 48.883 39.6674 48.883 35.3415C48.883 30.8207 48.0261 27.1407 46.0842 24.5292C44.1031 21.7504 41.2308 20.378 37.672 20.378C34.041 20.378 31.0342 21.4187 28.8909 23.6971C26.8722 25.7331 25.5375 28.416 24.8221 31.6518C24.1255 34.8025 23.7821 38.2223 23.7821 41.9049V46.8H1.5V41.5683C1.5 33.6457 2.70349 26.6593 5.07638 20.5836C7.53568 14.5703 11.3061 9.94239 16.3878 6.64352L16.3878 6.64353L16.3942 6.63934C21.5477 3.25652 28.3776 1.5 37.0023 1.5C48.6935 1.5 57.2242 4.57121 62.8763 10.4628C68.5625 16.39 71.5 24.7809 71.5 35.8463C71.5 41.1878 70.6873 46.1194 69.0769 50.6538C67.4424 55.1429 65.2606 59.5308 62.5266 63.8178L62.5266 63.8178L62.5212 63.8263C59.8527 68.0731 56.9605 72.4898 53.8441 77.0765L53.8386 77.0847L53.8332 77.0929L27.7139 116.642L26.1773 118.968H28.9656Z",
    stroke: "#767676",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1d3700efa06644fc0614e6ff4bca73a4.svg";
export { ForwardRef as ReactComponent };